module.exports = __webpack_public_path__ + "img/pe02.602ec271.jpg";